// extracted by mini-css-extract-plugin
export default {"brand":"Header_brand__lViDj","header":"Header_header__Lhnr8","header-divider":"Header_header-divider__EemSE","menu-icon":"Header_menu-icon__P+YyJ","logo":"Header_logo__nZ7K6"};